import { useMemo } from 'react'
import s from './Pills.scss'

const getFiltersLabels = filters => {
  const labels = []
  Object.keys(filters)
    .filter(f => !['startDate', 'endDate'].includes(f))
    .forEach(key => {
      if (filters[key]) {
        if (key === 'awarded') {
          labels.push('Awarded')
        } else {
          if (filters[key].length) {
            filters[key].forEach(value => {
              labels.push(value.label)
            })
          }
        }
      }
    })

  return labels
}

const Pills = ({ filters }) => {
  const labels = useMemo(() => getFiltersLabels(filters), [filters])
  const visibleFilters = labels.slice(0, 4)
  const hiddenFilters = labels.slice(4)

  return (
    <span className={s.pills}>
      {visibleFilters.map((label, index) => (
        <span className={s.pill} key={index}>
          {label}
        </span>
      ))}
      {hiddenFilters.length > 0 && <span className={s.pill}>+ {hiddenFilters.length} more</span>}
    </span>
  )
}

export default Pills
